<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약재재고관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>약재명</p>
                <input type="text" placeholder="약재명을 입력하세요" class="form_control" v-model="searchInfo.medicineNm">
              </li>
              <li>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="" checked v-model="searchInfo.chk_info" @change="fn_change_chkinfo">
                  <label for="radio1">전체</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio" value="lack" v-model="searchInfo.chk_info" @change="fn_change_chkinfo">
                  <label for="radio2">재고부족</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio3" name="radio" value="cmpt" v-model="searchInfo.chk_info" @change="fn_change_chkinfo">
                  <label for="radio3">사용완료</label>
                </div>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_excelDown"><i class="icon icon_excel"></i>재고엑셀다운로드</button>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="list">
              <colgroup>
                <col width="300">
              </colgroup>
              <thead>                  
                <tr>
                    <th>약재명</th>
                    <th>회사명</th>
                    <th>원산지</th>
                    <th>입고량</th>
                    <th>재고량</th>
                    <th>입고일자</th>
                    <th>사용완료</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="medStockList.length == 0">
                    <td colspan="10"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in medStockList" :key="index" :class="item.lack_qnty < item.med_stdr_invt_qy ? 'error' : ''">
                  <td><span>{{ item.med_hrb_nm }}</span></td>
                  <td><span>{{ item.company_nm }}</span></td>
                  <td><span>{{ item.org_plce_nm }}</span></td>
                  <td><span>{{ item.wrhs_qnty }}</span></td>
                  <td><span>{{ item.lack_qnty }}</span></td>
                   <td><span>{{ item.wrhs_dt }}</span></td>
                  <td><span>{{ item.use_cmpt_yn }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="moveGrpPage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import Datepicker from '@/components/Datepicker.vue'
    import * as XLSX from "xlsx";

export default {
    name: 'MedicineWrhsMngt',
    components: {
      Pagination,
      Datepicker,
    },
    data() {
      return {
        searchInfo : {
            medicineNm : '',
            chk_info : '',
            pageInfo : {
              page : '1',
              pageSize : '10',
              totPage : '0'
            } 
        },
        pagingShow : false,
        medStockList: [],
        changeChkInfo: false,
        isDownloading : false,
      }
    },
    async created(){
      let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
      if(searchInfoStore != null && searchInfoStore != {}){
          this.searchInfo = searchInfoStore
      }
    },
    mounted(){          
        this.fn_search();
    },
    methods : {
        fn_search(){

            //console.log("@@@@ regData : %o",this.regData);

            // 검색 정보 저장
            this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

            if(this.changeChkInfo){
              this.searchInfo.pageInfo.page = 1;
            }
            axios
                .post("/api/medicineWrhs/searchMedicineStock", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.medStockList = res.data.medStockInfo;

                    console.log("@@@@ medStockList : %o",this.medStockList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                    if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                    }
                    
                    if(this.changeChkInfo){
                      this.changeChkInfo = false;
                    }
                })
                .catch((err) => console.log(err));
            
        },
        moveGrpPage(page){
            this.searchInfo.pageInfo.page = page;
            this.fn_search();
        },
        fn_change_chkinfo(){
          this.changeChkInfo = true;
        },
        async fn_excelDown() {

          this.isDownloading = true

          try {

            const res = await axios.post(
                '/api/medicineWrhs/excelDownload',
                this.searchInfo,       // 검색 조건 전달
                {
                  responseType: 'blob',  // ← 핵심: 바이너리로 수신
                  timeout: 60000,
                }
            )

            // Blob → 다운로드
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            const url  = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href  = url
            link.download = `약재재고_${this.today()}.xlsx`
            link.click()
            URL.revokeObjectURL(url)   // 메모리 해제

          } catch (e) {
            alert('엑셀 다운로드 실패')
            console.error(e)
          } finally {
            this.isDownloading = false
          }

        },
        today() {
          return new Date().toISOString().slice(0, 10).replace(/-/g, '')
        }
    }   
  }
</script>